<ng-container *ngIf="isLoadingPermissions; else permissionsLoaded">
    <p class="sr-only" aria-live="polite">{{ 'Loading permissions' | translate: {Default: 'Loading permissions'} }}</p>
    <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
</ng-container>
<ng-template #permissionsLoaded>
    <mat-card class="mat-elevation-z0" *appTableAccess="[tableReadAccessObj]" role="region" aria-labelledby="personal-details-title">
    <mat-card-title class="header">
        <h2 id="personal-details-title" class="sr-only">{{ 'PersonalDetails' | translate: {Default: 'Personal Details'} }}</h2>
        <h2 *ngIf="showTitle" appLocalizationPopupDirective localizationCode="PersonalDetails">{{ 'PersonalDetails' | translate: {Default: "Personal Details"} }}</h2>
    
        <div class="k-flex-grow"></div>

        <div class="buttons-container">
        <mat-form-field appearance="fill" class="effective-date-form-field">
            <mat-label>
                {{ 'EffectiveDate' | translate: {Default: "Effective Date"} }}
            </mat-label>

            <input matInput [matDatepicker]="effectiveDatePicker" (dateChange)="effectiveDateChange($event)" [(ngModel)]="effectiveDate">
            <span fxLayout="row" matSuffix>
                <mat-datepicker-toggle [for]="effectiveDatePicker"></mat-datepicker-toggle>
            </span>
            <mat-datepicker #effectiveDatePicker></mat-datepicker>
        </mat-form-field>

        <button mat-icon-button type="button" class="icon-action-button k-mr-3"
            [attr.aria-label]="'Open access logs' | translate: {Default: 'Open access logs'}"
            appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openAccessLogsDialog()">
            <mat-icon
                setColor
                [setColorRules]="[
                {
                    color: 'primaryColour',
                    events: ['hover']
                }
                ]"
                class="material-icons-outlined"
                aria-hidden="true"
            >fingerprint</mat-icon>
        </button>
        <button mat-icon-button type="button" class="icon-action-button k-mr-3"
            [attr.aria-label]="'Open change history' | translate: {Default: 'Open change history'}"
            appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openHistoryDialog()">
            <mat-icon
                setColor
                [setColorRules]="[
                {
                    color: 'primaryColour',
                    events: ['hover']
                }
                ]"
                class="material-icons-outlined"
                aria-hidden="true"
            >history</mat-icon>
        </button>
        <button 
            mat-raised-button 
            setColor="primaryColour" 
            color="primary" 
            [disabled]="formValid === false" 
            [attr.aria-disabled]="formValid === false"
            appPreventDoubleClick 
            (throttledClick)="getFormData = !getFormData" 
            *appTableAccess="[tableCreateAccessObj, tableUpdateAccessObj]">
            {{ 'Save' | translate: {Default: "Save"} }}
        </button>
        </div>
    </mat-card-title>
    <mat-card-content role="form" [attr.aria-label]="'Personal details form' | translate: {Default: 'Personal details form'}">
        <ng-container *ngIf="isLoading; else loaded">
        <p class="sr-only" aria-live="polite">{{ 'Loading personal details form' | translate: {Default: 'Loading personal details form'} }}</p>
        <ngx-skeleton-loader
            count="5"
            [theme]="{ 
                'height.px': 50
            }"
        ></ngx-skeleton-loader>
        </ng-container>
        <ng-template #loaded>
        <app-form-generator 
            [formId]="formId"
            [formData]="formData"
            [emitFormDataTrigger]="getFormData"
            [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
            (emitFormData)="formDataEmitted($event)"
            (emitFormStatus)="formStatusUpdated($event)"
            (emitFormPristine)="formPristineEmitted($event)"
        ></app-form-generator>
        </ng-template>
    </mat-card-content>
    </mat-card>
</ng-template>